import { useAppSelector } from "../../../../redux/hooks";
import { CooperativeProfileEdit } from "./cooperative/edit";
import { MemberProfileEdit } from "./member/edit";

export const ProfileEdit = () => {
  const profile = useAppSelector((state) => {
    return state.auth.profile;
  });

  return profile?.type === "cooperative" ? (
    <CooperativeProfileEdit />
  ) : (
    <MemberProfileEdit />
  );
};
